import { Routes, Route, Navigate, useLocation } from 'react-router-dom'
import { useEffect } from 'react'
import Layout from './components/Layout'
import analytics from './utils/analytics'
import Home from './pages/Home'
import Services from './pages/Services'
import About from './pages/About'
import Contact from './pages/Contact'

// Service pages
import DevelopmentServices from './pages/services/DevelopmentServices'
import ManagedDesktops from './pages/services/ManagedDesktops'
import ManagedHelpDesk from './pages/services/ManagedHelpDesk'
import ManagedSecurity from './pages/services/ManagedSecurity'
import NetworkOperations from './pages/services/NetworkOperations'
import ProjectRecovery from './pages/services/ProjectRecovery'
import TechnologyConcierge from './pages/services/TechnologyConcierge'
import WhiteGloveService from './pages/services/WhiteGloveService'
import TechnologyMagic from './pages/services/TechnologyMagic'

function App() {
  const location = useLocation();

  // Track page views on route changes
  useEffect(() => {
    analytics.trackPageView(location.pathname);
  }, [location]);

  return (
    <Layout>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/index.html" element={<Navigate to="/" replace />} />
        
        {/* Services routes */}
        <Route path="/services.html" element={<Navigate to="/services" replace />} />
        <Route path="/services" element={<Services />} />
        <Route path="/services/development-services" element={<DevelopmentServices />} />
        <Route path="/services/managed-desktops" element={<ManagedDesktops />} />
        <Route path="/services/managed-help-desk" element={<ManagedHelpDesk />} />
        <Route path="/services/managed-security" element={<ManagedSecurity />} />
        <Route path="/services/network-operations" element={<NetworkOperations />} />
        <Route path="/services/project-recovery" element={<ProjectRecovery />} />
        <Route path="/services/technology-concierge" element={<TechnologyConcierge />} />
        <Route path="/services/white-glove-service" element={<WhiteGloveService />} />
        <Route path="/services/technology-magic" element={<TechnologyMagic />} />
        
        {/* Other routes */}
        <Route path="/aboutus.html" element={<Navigate to="/about" replace />} />
        <Route path="/about" element={<About />} />
        <Route path="/contactus.html" element={<Navigate to="/contact" replace />} />
        <Route path="/contact" element={<Contact />} />
      </Routes>
    </Layout>
  )
}

export default App
